export default __webpack_public_path__ + "static/07_M-3a87fc8f50f78bf189db79b0ee0b1896.pdf";